// ===========================================================================
// billingDashboard — constantes, formatters y VALORES ESTÁNDAR del dashboard
// de Billing & Revenue Integrity.
//
// El dashboard se alimenta de datos REALES (cost of care + coding/recapture,
// vía ceoDataService). Lo que el backend aún NO expone (claims/AR/denials/
// payments/payer mix) se rellena con VALORES ESTÁNDAR marcados en la UI con el
// chip "est." y documentado en docs/modulos/dashboards/BILLING_DASHBOARD.md.
// ===========================================================================

// Valor estándar de captura por oportunidad HCC (placeholder determinista).
// El backend no expone RAF$ por oportunidad; usamos un valor de reembolso
// incremental promedio por HCC capturado. Ajustar cuando exista el dato real.
export const STANDARD_RAF_VALUE_PER_OPP = 1200; // USD por oportunidad

// ── Formatters de moneda ───────────────────────────────────────────────────
export function formatMoney(n) {
  if (n == null || Number.isNaN(Number(n))) return "—";
  return `$${Math.round(Number(n)).toLocaleString("en-US")}`;
}

export function formatMoneyCompact(n) {
  if (n == null || Number.isNaN(Number(n))) return "—";
  const v = Number(n);
  const abs = Math.abs(v);
  if (abs >= 1_000_000) return `$${(v / 1_000_000).toFixed(1)}M`;
  if (abs >= 1_000) return `$${(v / 1_000).toFixed(1)}K`;
  return `$${Math.round(v)}`;
}

export function formatNumber(n) {
  if (n == null || Number.isNaN(Number(n))) return "—";
  return Number(n).toLocaleString("en-US");
}

// ── DATOS ESTÁNDAR (placeholder) — requieren backend de billing/claims ──────
// Revenue cycle: estos KPIs NO existen aún en los endpoints. Son valores
// estándar de referencia para que el equipo de billing valide el layout.
export const STANDARD_REVENUE_CYCLE = {
  cleanClaimRatePct: 94.2, // % de claims aceptados a la primera
  denialRatePct: 6.1, // % de claims denegados
  daysInAR: 32, // días promedio en cuentas por cobrar
  firstPassYieldPct: 88.5,
};

// AR aging buckets (estándar) — en prod: GET /api/billing/ar-aging
export const STANDARD_AR_AGING = [
  { bucket: "0–30", amount: 1180000 },
  { bucket: "31–60", amount: 540000 },
  { bucket: "61–90", amount: 285000 },
  { bucket: "90+", amount: 196000 },
];

// Payer mix (estándar) — en prod: GET /api/billing/payer-mix
export const STANDARD_PAYER_MIX = [
  { id: "Medicare Advantage", label: "Medicare Advantage", value: 58 },
  { id: "Medicaid", label: "Medicaid", value: 18 },
  { id: "ACA / Marketplace", label: "ACA / Marketplace", value: 16 },
  { id: "Commercial", label: "Commercial", value: 6 },
  { id: "Self-pay", label: "Self-pay", value: 2 },
];

// Categorías de costo → color para charts (alineado a cost/summary breakdown).
export const COST_CATEGORY_COLORS = {
  "Inpatient Cost": "#EF4444",
  "Outpatient Cost": "#3B82F6",
  "Emergency Room Cost": "#F59E0B",
  "Professional Cost": "#8B5CF6",
  "Pharmacy Cost": "#10B981",
  "Virtual Visit Cost": "#06B6D4",
};
